import { PARLACEN_TV_STATUS } from '../enums/enums';

export class ParlacenTV {
  constructor(
    public id:            string,
    public title:         string,
    public description:   string,
    public video:         string,
    public tag:           string,
    public creationDate:  string,
    public status:        PARLACEN_TV_STATUS,
  ) { }
}